// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlight-title {\n  font-size: 1.4em;\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n.highlight-content {\n  font-size: 1.3em;\n  font-weight: 500;\n}\n\n.highlight-extra {\n  font-size: 0.5em;\n  color: #777575;\n}\n\n@media only screen and (max-width: 576px) {\n  .highlight-title {\n    font-size: 1em;\n    text-transform: capitalize;\n    font-weight: 500;\n  }\n\n  .highlight-content {\n    font-size: 0.875em;\n    font-weight: 500;\n  }\n}", ""]);
// Exports
module.exports = exports;
